"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputTypes = void 0;
var react_1 = __importStar(require("react"));
var dayjs_1 = __importDefault(require("dayjs"));
var QueriesStore_1 = require("stores/QueriesStore");
var Notification_1 = require("components/core/Notification");
var use_notification_1 = require("hooks/use-notification");
var UserStore_1 = __importStar(require("stores/UserStore"));
var Button_1 = __importDefault(require("components/core/buttons/Button"));
var Loading_1 = __importDefault(require("components/core/Loading"));
var InputTypes;
(function (InputTypes) {
    InputTypes[InputTypes["CREATE"] = 0] = "CREATE";
    InputTypes[InputTypes["EDIT"] = 1] = "EDIT";
})(InputTypes = exports.InputTypes || (exports.InputTypes = {}));
var IPCRowInput = function (_a) {
    var queryType = _a.queryType, type = _a.type, queryAction = _a.queryAction, onSubmit = _a.onSubmit, busy = _a.busy, currentData = _a.currentData, currentStage3 = _a.currentStage3, dummyOrder = _a.dummyOrder;
    var _b = react_1.useState(currentData || null), data = _b[0], setData = _b[1];
    var notification = use_notification_1.useNotification();
    react_1.useEffect(function () {
        if (!currentData) {
            var data_1 = { quantity: 1 };
            if (queryType === QueriesStore_1.QueryTypes.POD) {
                if (dummyOrder)
                    data_1.ipcType = QueriesStore_1.IPCTypes.DUMMY;
                else
                    data_1.ipcType = QueriesStore_1.IPCTypes.RETURNS;
            }
            else
                data_1.invoiceDate = dayjs_1.default().format("YYYY-MM-DD");
            setData(data_1);
        }
        else {
            setData(currentData);
        }
    }, [currentData]);
    var changeHandler = function (e) {
        var _a;
        setData(__assign(__assign({}, data), (_a = {}, _a[e.currentTarget.name] = e.currentTarget.value, _a)));
    };
    var submitHandler = function (e) {
        e.preventDefault();
        var error = null;
        if (data === null) {
            error = "Please enter the IPC Number and Quantity";
        }
        if ((!data.ipcNumber || data.ipcNumber.length <= 0) && currentStage3 === QueriesStore_1.PODStage3Parts.WAREHOUSE_1) {
            error = "Please enter the IPC Number";
        }
        if ((!data.quantity || data.quantity <= 0) && currentStage3 === QueriesStore_1.PODStage3Parts.WAREHOUSE_1) {
            error = "Please enter the Quantity";
        }
        if (dummyOrder) {
            if ((!data.creditText || data.creditText.length <= 0) && currentStage3 === QueriesStore_1.PODStage3Parts.CREDIT) {
                error = "Please enter the credit text";
            }
            if ((!data.orderNumberReturnRef || data.orderNumberReturnRef.length <= 0) && currentStage3 === QueriesStore_1.PODStage3Parts.CUSTOMER_SERVICES && data.ipcType === QueriesStore_1.IPCTypes.ORDER) {
                error = "Please enter dummy order number";
            }
            if ((!data.deliveryNote || data.deliveryNote.length <= 0) && currentStage3 === QueriesStore_1.PODStage3Parts.CUSTOMER_SERVICES && data.ipcType === QueriesStore_1.IPCTypes.ORDER) {
                error = "Please enter delivery note";
            }
        }
        if (error !== null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error
            });
            return;
        }
        onSubmit(data);
        if (queryType === QueriesStore_1.QueryTypes.POD) {
            var ipcType = QueriesStore_1.IPCTypes.RETURNS;
            if (dummyOrder) {
                data.ipcType = QueriesStore_1.IPCTypes.DUMMY;
            }
            setData({
                invoiceDate: dayjs_1.default().format("YYYY-MM-DD"),
                quantity: 1,
                ipcType: ipcType
            });
        }
        else {
            setData({
                invoiceDate: dayjs_1.default().format("YYYY-MM-DD"),
                quantity: 1
            });
        }
    };
    var checkCorrectStage3User = function () {
        if (!data)
            return false;
        return data.ipcType === QueriesStore_1.IPCTypes.DUMMY &&
            queryType === QueriesStore_1.QueryTypes.POD &&
            type === InputTypes.EDIT &&
            UserStore_1.default.hasPermission(UserStore_1.Permissions.POD_QUERY_CUSTOMER_SERVICES_TEAM) ||
            queryType === QueriesStore_1.QueryTypes.POD &&
                type === InputTypes.EDIT &&
                data.ipcType === QueriesStore_1.IPCTypes.RETURNS &&
                UserStore_1.default.hasPermission(UserStore_1.Permissions.POD_QUERY_WAREHOUSE_TEAM) &&
                currentStage3 === QueriesStore_1.PODStage3Parts.WAREHOUSE_2;
    };
    return (react_1.default.createElement("form", { className: "ipc-row-input flex flex-row " + (type === InputTypes.EDIT && "edit" || ""), onSubmit: submitHandler },
        queryAction === QueriesStore_1.QueryActions.CREDIT_DEBIT &&
            react_1.default.createElement("div", { className: "row-input" },
                react_1.default.createElement("input", { type: "text", name: "acNumber", placeholder: "A/C Number", value: data !== null && data.acNumber || "", onChange: changeHandler })),
        queryType !== QueriesStore_1.QueryTypes.POD &&
            react_1.default.createElement("div", { className: "row-input" },
                react_1.default.createElement("input", { type: "text", name: "billRef", placeholder: "Bill Ref", value: data !== null && data.billRef || "", onChange: changeHandler })),
        queryType !== QueriesStore_1.QueryTypes.POD &&
            react_1.default.createElement("div", { className: "row-input" },
                react_1.default.createElement("input", { type: "text", name: "invoiceNumber", placeholder: "Invoice No", value: data !== null && data.invoiceNumber || "", onChange: changeHandler })),
        queryType === QueriesStore_1.QueryTypes.PRICE &&
            react_1.default.createElement("div", { className: "row-input mid-small" },
                react_1.default.createElement("input", { type: "text", name: "orderNo", placeholder: "Order No", value: data !== null && data.orderNo || "", onChange: changeHandler })),
        queryType === QueriesStore_1.QueryTypes.POD &&
            UserStore_1.default.hasPermission(UserStore_1.Permissions.POD_QUERY_WAREHOUSE_TEAM) &&
            currentStage3 === QueriesStore_1.PODStage3Parts.WAREHOUSE_1 ?
            react_1.default.createElement("div", { className: "row-input" },
                react_1.default.createElement("select", { name: "ipcType", placeholder: "Order No", value: data !== null && data.ipcType || QueriesStore_1.IPCTypes.RETURNS, onChange: changeHandler }, dummyOrder ?
                    react_1.default.createElement("option", { value: QueriesStore_1.IPCTypes.DUMMY }, QueriesStore_1.IPCTypes.DUMMY)
                    :
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("option", { value: QueriesStore_1.IPCTypes.RETURNS }, QueriesStore_1.IPCTypes.RETURNS),
                            react_1.default.createElement("option", { value: QueriesStore_1.IPCTypes.ORDER }, QueriesStore_1.IPCTypes.ORDER))))
            :
                queryType === QueriesStore_1.QueryTypes.POD &&
                    react_1.default.createElement("div", { className: "space-filler" }, "\u00A0"),
        queryType !== QueriesStore_1.QueryTypes.POD &&
            react_1.default.createElement("div", { className: "row-input mid-small" },
                react_1.default.createElement("input", { type: "date", name: "invoiceDate", placeholder: "Invoice Date", value: data !== null && dayjs_1.default(data.invoiceDate).format("YYYY-MM-DD") || dayjs_1.default().format("YYYY-MM-DD"), onChange: changeHandler })),
        queryType !== QueriesStore_1.QueryTypes.POD ||
            queryType === QueriesStore_1.QueryTypes.POD &&
                UserStore_1.default.hasPermission(UserStore_1.Permissions.POD_QUERY_WAREHOUSE_TEAM) &&
                currentStage3 === QueriesStore_1.PODStage3Parts.WAREHOUSE_1 ?
            react_1.default.createElement("div", { className: "row-input " + (queryType !== QueriesStore_1.QueryTypes.POD && "small") },
                react_1.default.createElement("input", { type: "text", name: "ipcNumber", placeholder: queryType !== QueriesStore_1.QueryTypes.POD && "IPC" || "IPC Number", value: data !== null && data.ipcNumber || "", onChange: changeHandler }))
            :
                queryType === QueriesStore_1.QueryTypes.POD &&
                    react_1.default.createElement("div", { className: "space-filler" }, "\u00A0"),
        queryType === QueriesStore_1.QueryTypes.FLEET &&
            react_1.default.createElement("div", { className: "row-input" },
                react_1.default.createElement("input", { type: "text", name: "deliveryNumber", placeholder: "Worksheet No", value: data !== null && data.deliveryNumber || "", onChange: changeHandler })),
        queryType === QueriesStore_1.QueryTypes.FLEET &&
            react_1.default.createElement("div", { className: "row-input" },
                react_1.default.createElement("input", { type: "text", name: "poNumber", placeholder: "PO Number", value: data !== null && data.poNumber || "", onChange: changeHandler })),
        queryType === QueriesStore_1.QueryTypes.FLEET &&
            react_1.default.createElement("div", { className: "row-input small" },
                react_1.default.createElement("input", { type: "text", name: "taxCode", placeholder: "Tax Code", value: data !== null && data.taxCode || "", onChange: changeHandler })),
        queryType !== QueriesStore_1.QueryTypes.POD ||
            queryType === QueriesStore_1.QueryTypes.POD &&
                UserStore_1.default.hasPermission(UserStore_1.Permissions.POD_QUERY_WAREHOUSE_TEAM) &&
                currentStage3 === QueriesStore_1.PODStage3Parts.WAREHOUSE_1 ?
            react_1.default.createElement("div", { className: "row-input " + (queryType !== QueriesStore_1.QueryTypes.POD && "small") },
                react_1.default.createElement("input", { type: "number", min: 1, step: 1, name: "quantity", placeholder: "QTY", value: data !== null && data.quantity || 1, onChange: changeHandler }))
            :
                queryType === QueriesStore_1.QueryTypes.POD &&
                    react_1.default.createElement("div", { className: "space-filler" }, "\u00A0"),
        queryType !== QueriesStore_1.QueryTypes.POD &&
            react_1.default.createElement("div", { className: "row-input small" },
                react_1.default.createElement("input", { type: "number", step: 0.1, name: "itemNet", placeholder: "Item Net", value: data !== null && data.itemNet || "", onChange: changeHandler })),
        queryType !== QueriesStore_1.QueryTypes.POD &&
            react_1.default.createElement("div", { className: "row-input small" },
                react_1.default.createElement("input", { type: "number", step: 0.1, name: "newNet", placeholder: "New Net", value: data !== null && data.newNet || "", onChange: changeHandler })),
        queryType === QueriesStore_1.QueryTypes.POD &&
            type === InputTypes.EDIT &&
            UserStore_1.default.hasPermission(UserStore_1.Permissions.POD_QUERY_CREDIT_TEAM) ?
            react_1.default.createElement("div", { className: "row-input" },
                react_1.default.createElement("input", { type: "text", name: "creditText", placeholder: "Credit Text", value: data !== null && data.creditText || "", onChange: changeHandler }))
            :
                queryType === QueriesStore_1.QueryTypes.POD &&
                    react_1.default.createElement("div", { className: "space-filler" }, "\u00A0"),
        checkCorrectStage3User() ?
            react_1.default.createElement("div", { className: "row-input" },
                react_1.default.createElement("input", { type: "text", name: "orderNumberReturnRef", placeholder: "Order Number / Returns Ref", value: data !== null && data.orderNumberReturnRef || "", onChange: changeHandler }))
            :
                queryType === QueriesStore_1.QueryTypes.POD &&
                    react_1.default.createElement("div", { className: "space-filler" }, "\u00A0"),
        checkCorrectStage3User() ?
            react_1.default.createElement("div", { className: "row-input" },
                react_1.default.createElement("input", { type: "text", name: "deliveryNote", placeholder: "Delivery Note", value: data !== null && data.deliveryNote || "", onChange: changeHandler }))
            :
                queryType === QueriesStore_1.QueryTypes.POD &&
                    react_1.default.createElement("div", { className: "space-filler" }, "\u00A0"),
        queryType === QueriesStore_1.QueryTypes.POD &&
            type === InputTypes.EDIT &&
            UserStore_1.default.hasPermission(UserStore_1.Permissions.POD_QUERY_WAREHOUSE_TEAM) ?
            react_1.default.createElement("div", { className: "row-input" },
                react_1.default.createElement("select", { name: "goodsIssue", placeholder: "Goods Issue", value: data !== null && typeof data.goodsIssue !== "undefined" && data.goodsIssue !== null && data.goodsIssue.toString() || "false", onChange: changeHandler },
                    react_1.default.createElement("option", { value: "true" }, "Goods Issued"),
                    react_1.default.createElement("option", { value: "false" }, "Goods Not Issued")))
            :
                queryType === QueriesStore_1.QueryTypes.POD &&
                    react_1.default.createElement("div", { className: "space-filler" }, "\u00A0"),
        react_1.default.createElement("div", { className: "add" },
            react_1.default.createElement(Button_1.default, { type: "submit", icon: busy && react_1.default.createElement(Loading_1.default, null) || null, title: type === InputTypes.EDIT && "Save" || "Save & Next" }, type === InputTypes.EDIT && "Save" || "Save & Next"))));
};
exports.default = IPCRowInput;
